import { createReducer, AnyAction } from '@reduxjs/toolkit';
import { ActionType } from './actions';

export interface AppState {
  cache: {[userId: number]: string};
}

export interface AvatarCacheItem {
  userId: number,
  url: string,
}

const initialState: AppState = {
  cache: {},
};

const avatarReducer = createReducer(initialState, {
  [ActionType.SET]: (state: AppState, action: AnyAction): AppState => {
    const cache = { ...state.cache };
    const item = action.payload as AvatarCacheItem;
    cache[item.userId] = item.url;
    return { ...state, cache };
  },
});

export default avatarReducer;
